import cloneDeep from 'lodash/cloneDeep';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import { useBookingPath } from '../graphql';
import useFlightSearchCriteria from './useFlightSearchCriteria';

// This hook is for Allegiant Stadium Games
// The game data is set in the landing page (when the user selects a game)
const useStadiumGame = () => {
  const [stadiumGame, setStadiumGame] = useState({});
  const { showsOrderItem } = useBookingPath();
  const { data: flightSearchCritieriaData } = useFlightSearchCriteria();
  const router = useRouter();
  const { query } = router;

  const travelersCount =
    flightSearchCritieriaData?.adultsCount +
      flightSearchCritieriaData?.childrenCount +
      flightSearchCritieriaData?.infantCount || 0;

  const _setStadiumGame = game => {
    setStadiumGame(cloneDeep(game));
    if (typeof window === 'object') {
      window.localStorage.setItem(`selectedStadiumGame`, JSON.stringify(game));
    }
  };

  useEffect(() => {
    let gameDetails = getSelectedGameFromQueryOrCart(
      query,
      showsOrderItem,
      travelersCount
    );
    _setStadiumGame(gameDetails);
  }, [showsOrderItem, query, travelersCount]);

  const _stadiumGame = {
    date: stadiumGame.date,
    quantity: stadiumGame.quantity,
    conditions: {
      OPPONENT_CITY: stadiumGame.showConditions?.OPPONENT_CITY,
      PACKAGE_ID: stadiumGame.showConditions?.PACKAGE_ID,
      OPPONENT_NAME: stadiumGame.showConditions?.OPPONENT_NAME,
    },
    sectionId: stadiumGame.sectionId,
    seatIds: stadiumGame.seatIds,
  };
  return [_stadiumGame, _setStadiumGame];
};
export default useStadiumGame;

const getSelectedGameFromQueryOrCart = (
  query,
  showsOrderItem,
  travelersCount
) => {
  const { ta, tc, tis, sgd, stc, stn, spid, sectionId, seatIds } = query;
  let seatIdsFromCart = showsOrderItem?.map(show => show.show.categoryCode);

  // sectionIdFromCartOrQuery => selected section id from either the query paramters or cart
  let sectionIdFromCartOrQuery =
    sectionId || showsOrderItem?.[0]?.show?.meta?.SECTION_NUMBER;

  // seatIdsArray => selected seat ids from either the query paramters or cart
  let seatIdsArray =
    typeof seatIds === 'string'
      ? seatIds?.split(',')
      : seatIdsFromCart?.length > 0
      ? seatIdsFromCart
      : [];

  let ticketQuantityFromQuery = parseInt(ta) + parseInt(tc) + parseInt(tis);

  let ticketQuantityFromOrder =
    showsOrderItem?.length < travelersCount
      ? travelersCount
      : showsOrderItem?.length;

  return {
    showConditions: {
      OPPONENT_CITY: showsOrderItem?.[0]?.show?.meta?.OPPONENT_CITY || stc,
      OPPONENT_NAME: showsOrderItem?.[0]?.show?.meta?.OPPONENT_NAME || stn,
      PACKAGE_ID: showsOrderItem?.[0]?.show?.meta?.PACKAGE_ID || spid,
    },
    date: showsOrderItem?.[0]?.show?.date || sgd,
    quantity: ticketQuantityFromOrder || ticketQuantityFromQuery,
    sectionId: sectionIdFromCartOrQuery,
    seatIds: seatIdsArray,
  };
};
